import React  from 'react';
import {Container, Button, Col, Row, View} from 'mdbreact' 

const Inicio = () => {
	return (
		<div id="apppage" className="container-fluid text-center">

      <View>
        <Container>
          <Row>
            {/* <Col md="8" xl="5" className="mt-xl-5"> */}
              <div className="white-text text-center text-md-left col-md-6 mt-xl-5 mb-5">
                <h1 className="h1-responsive font-weight-bold mt-sm-5">Make purchases with our app </h1>
                <hr className="hr-light"/>
                <h6 className="mb-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem repellendus quasi fuga nesciunt
                dolorum nulla magnam veniam sapiente, fugiat! Commodi sequi non animi ea dolor molestiae
                iste.</h6>
                <Button color="white">Download</Button>
                <Button outline color="white">Learn More</Button>
              </div>
            {/* </Col> */}
            <Col md="4" xl="5" className="mt-xl-5">
              {/* <img src='Picture5.png' className="img-fluid"/> */}
              <img src="https://mdbootstrap.com/img/Mockups/Transparent/Small/admin-new.png" className="img-fluid  border border-dark" alt=''/>
            </Col>
          </Row>
        </Container>
      </View>
    </div>
	)
}

export default Inicio


// WEBPACK FOOTER //
// ./src/paginas/Inicio.js